import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';

import IconFolder from 'components/icons/IconFolder';
import Section, {
  SectionHeader, SectionTitle, SectionBody, SectionBodyEmptyContent,
} from 'components/common/Section';
import SortableList from 'components/common/SortableList';

import { changePatientResource } from 'redux/modules/patients';

import DiagnosesItem from './DiagnosesItem';
import DiagnosesAddForm from './DiagnosesAddForm';

const styles = () => ({
  form: {
    width: '65%',
  },
  iconFolder: {
    width: 20,
    height: 16,
  },
  list: {
    position: 'relative',
  },
});

class Diagnoses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(diagnosisID) {
    const { patient, actions } = this.props;
    this.setState({ loading: true });
    actions.changePatientResource({
      'Record Number': patient['Record Number'],
      'Diagnosis ID': diagnosisID,
      resolve: () => {
        this.setState({ loading: false });
      },
      reject: () => {
        this.setState({ loading: false });
      },
    });
  }

  render() {
    const { patient, business, classes } = this.props;
    const { loading } = this.state;
    return (
      <Section>
        <SectionHeader>
          <SectionTitle>
            Diagnoses
          </SectionTitle>
          <DiagnosesAddForm
            className={classes.form}
            disabled={!patient}
            variant="default"
            onSubmitSuccess={(values) => {
              this.onChange([
                values.ID,
                ...patient.Diagnosis.map(item => item.ID),
              ]);
            }}
            diagnosis={patient.Diagnosis}
          />
        </SectionHeader>
        <SectionBody
          {...(!patient || patient.Diagnosis.length === 0) ? { padding: 'none' } : {}}
        >
          {(!patient || patient.Diagnosis.length === 0) ? (
            <SectionBodyEmptyContent
              text="There are no diagnoses yet"
              icon={(
                <IconFolder className={classes.iconFolder} />
              )}
            />
          ) : (
            <SortableList
              id="sortableListDiagnoses"
              items={patient.Diagnosis}
              itemComponent={DiagnosesItem}
              business={business}
              dragDisabled={loading}
              onSortingChange={(values) => {
                this.onChange(values.sortedItems.map(item => item.ID));
              }}
            />
          )}
        </SectionBody>
      </Section>
    );
  }
}

Diagnoses.propTypes = {
  patient: PropTypes.shape({
    'Record Number': PropTypes.number,
    Diagnosis: PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number.isRequired,
    })).isRequired,
  }),
  actions: PropTypes.shape({
    changePatientResource: PropTypes.func.isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
    iconFolder: PropTypes.string.isRequired,
    list: PropTypes.string.isRequired,
  }).isRequired,
};

Diagnoses.defaultProps = {
  patient: null,
  business: {},
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ changePatientResource }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(Diagnoses),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Diagnoses/Diagnoses.js